/* eslint-disable no-unused-vars */

import { Box, Button, Center, Group, Image, Text, Textarea } from '@mantine/core';
import { IconLogin, IconLogout } from '@tabler/icons-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import ModalPopupComponent from 'components/ModalPopup';
import { useAuth } from 'hooks/useAuth';
import React, { useState } from 'react';
import { courseService } from 'services/lcms/course.service';
import { showSuccessNotification } from 'utils/notification';
interface ModalCheckInOutProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: (callback: () => void) => void;
  isLoading?: boolean;
  title?: string;
  courseId: string;
  type?: 'checkin' | 'checkout';
}
const ModalCheckInOut: React.FC<ModalCheckInOutProps> = ({
  opened,
  onClose,
  onConfirm,
  isLoading,
  courseId,
  type = 'checkin',
  title = 'Redirecting to Beelajar LMS'
}) => {
  const { profile } = useAuth();
  const queryClient = useQueryClient();
  const [reasonInput, setReasonInput] = useState<string>('');

  const sendReason = useMutation({
    mutationFn: () =>
      courseService.createReason({
        msLCMSCourseID: courseId,
        binusianId: profile?.adminID as string,
        reason: reasonInput
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['lcmsDetail', courseId]
      });
      showSuccessNotification({
        title: 'Success',
        message: 'Reason has been sent'
      });
      setReasonInput('');
    }
  });

  const handleConfirm = () => {
    if (type === 'checkout') {
      onConfirm(() => sendReason.mutate());
      return;
    }
    onConfirm(() => {});
  };
  return (
    <ModalPopupComponent title={title} size='lg' opened={opened} close={onClose}>
      <Center>
        <div>
          <Image
            src={
              type === 'checkin'
                ? '/images/illustration-check-list.svg'
                : '/images/illustration-team.svg'
            }
            alt='Check to Beelajar LMS'
            w={153}
            h={153}
          />
        </div>
      </Center>

      <Text>
        This will take you to the Beelajar Learning Management System to{' '}
        {type === 'checkin' ? 'start revise' : 'end revise'} your courses, assignments, and learning
        resources.
      </Text>
      <Text>
        Are you sure to {type === 'checkin' ? 'start revise' : 'end revise'}{' '}
        <strong>Beelajar LMS</strong>?
      </Text>
      {type === 'checkout' && (
        <Box my={16}>
          <Textarea
            placeholder='Input Reason'
            label='Reason Revise'
            description='Input more than 10 characters'
            minRows={4}
            maxRows={8}
            value={reasonInput}
            onChange={(e) => setReasonInput(e.target.value)}
          />
        </Box>
      )}
      <Group justify='flex-end' mt={'md'}>
        <Button variant='outline' onClick={onClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button
          loading={isLoading}
          leftSection={type === 'checkin' ? <IconLogin /> : <IconLogout />}
          disabled={
            isLoading ||
            (type === 'checkout' && (!reasonInput || reasonInput.length < 10)) ||
            sendReason.isPending
          }
          onClick={handleConfirm}
        >
          {type === 'checkin' ? 'Start revise' : 'End revise'} on Beelajar LMS
        </Button>
      </Group>
    </ModalPopupComponent>
  );
};

export default ModalCheckInOut;
